import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { sanitizeLeadUpdatePayload } from 'src/app/utils/lead-profile-field.util';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LeadService {

  constructor(private api: ApiService) { }


  getLeadsRocord(data: any): Observable<any> {
    return this.api.post(environment.getLeadsRocord, data);
  }

  updateLeadField(data: any): Observable<any> {
    return this.api.post(environment.updateLeadField, data);
  }
  deleteLeadField(data: any): Observable<any> {
    return this.api.post(environment.deleteLeadField, data);
  }
  addLeadField(data: any): Observable<any> {
    return this.api.post(environment.addLeadField, data);
  }
  getLeadsFields(data: any): Observable<any> {
    return this.api.post(environment.getLeadsFields, data);
  }
  getAllData(data: any): Observable<any> {
    return this.api.post(environment.getAllLeads, data);
  }
  getFilteredLeads(data: any): Observable<any> {
    return this.api.post(environment.getFilteredLeads, data);
  }
  addLeadData(data: any): Observable<any> {
    return this.api.post(environment.createLead, data);
  }
  deleteLeadData(data: any): Observable<any> {
    return this.api.post(environment.deleteLead, data);
  }
  getLead(data: any): Observable<any> {
    return this.api.post(environment.getLead, data);
  }
  updateLead(data: any): Observable<any> {
    return this.api.post(environment.updateLead, sanitizeLeadUpdatePayload(data));
  }
  getLeadsFollowup(data: any): Observable<any> {
    return this.api.post(environment.getLeadsFollowup, data);
  }
  addLeadFollowUp(data: any): Observable<any> {
    return this.api.post(environment.createleadsfollowup, data);
  }
  addSubcriberList(data: any): Observable<any> {
    return this.api.post(environment.createSubsciberList, data);
  }
  getAllSubscriberList(data: any): Observable<any> {
    return this.api.post(environment.getAllSubsciberList, data);
  }
  deleteSubscriberList(data: any): Observable<any> {
    return this.api.post(environment.deleteSubsciberList, data);
  }
  getSubsciberList(data: any): Observable<any> {
    return this.api.post(environment.getSubsciberList, data);
  }
  getAllTemplates(data: any): Observable<any> {
    return this.api.post(environment.getAllTemplates, data);
  }

  addCampaignList(data: any): Observable<any> {
    return this.api.post(environment.createCampaignList, data);
  }

  updateCampaignList(data: any): Observable<any> {
    return this.api.post(environment.updateCampaignList, data);
  }

  getAllCampaignList(data: any): Observable<any> {
    return this.api.post(environment.getAllCampaignList, data);
  }
  deleteCampaignList(data: any): Observable<any> {
    return this.api.post(environment.deleteCampaignList, data);
  }

  sendWhatsappMsg(data: any): Observable<any> {
    return this.api.post(environment.sendWhatsappMsg, data);
  }

  sendMediaTemplateMsg(data: any): Observable<any> {
    return this.api.post(environment.sendMediaTemplateMsg, data);
  }

  sendTextTemplateMsg(data: any): Observable<any> {
    return this.api.post(environment.sendTextTemplateMsg, data);
  }

  createBulkLead(data: any): Observable<any> {
    return this.api.post(environment.createBulkLead, data);
  }

  createLeadSpace(data: any): Observable<any> {
    return this.api.post(environment.createLeadSpace, data);
  }
  getAllLeadSpace(data: any): Observable<any> {
    return this.api.post(environment.getAllLeadSpace, data);
  }

  deleteLeadSpace(data: any): Observable<any> {
    return this.api.post(environment.deleteLeadSpace, data);
  }

  updateLeadSpace(data: any): Observable<any> {
    return this.api.post(environment.updateLeadSpace, data);
  }


  CreateCommunicationHisLog(data: any): Observable<any> {
    return this.api.post(environment.CreateCommunicationHisLog, data);
  }

  UpdateCommunicationHisLog(data: any): Observable<any> {
    return this.api.post(environment.UpdateCommunicationHisLog, data);
  }

  getAllEmailTemplates(data: any): Observable<any> {
    return this.api.post(environment.getAllEmailTemplates, data);
  }

  getEmailTemplateById(data: any): Observable<any> {
    return this.api.post(environment.getEmailTemplateById, data);
  }

  sendEmail(data: any): Observable<any> {
    return this.api.post(environment.sendEmail, data);
  }

  getCommunicationHisLogs(data: any): Observable<any> {
    return this.api.post(environment.getCommunicationHisLog, data);
  }

  getAllTasks(data: any): Observable<any> {
    return this.api.post(environment.getAllTasks, data);
  }

  addTask(data: any): Observable<any> {
    return this.api.post(environment.createTask, data);
  }

  deleteTask(data: any): Observable<any> {
    return this.api.post(environment.deleteTask, data);
  }

  updateTask(data: any): Observable<any> {
    return this.api.post(environment.updateTask, data);
  }

  getAllNotes(data: any): Observable<any> {
    return this.api.post(environment.getAllNotes, data);
  }

  addNote(data: any): Observable<any> {
    return this.api.post(environment.createNote, data);
  }

  updateNote(data: any): Observable<any> {
    return this.api.post(environment.updateNote, data);
  }

  updateBulkLead(data: any): Observable<any> {
    return this.api.post(environment.updateBulkLead, sanitizeLeadUpdatePayload(data));
  }

  deleteNote(data: any): Observable<any> {
    return this.api.post(environment.deleteNote, data);
  }

  createAppointment(data: any): Observable<any> {
    return this.api.post(environment.createAppointment, data);
  }

  getAllAppointment(data: any): Observable<any> {
    return this.api.post(environment.getAllAppointment, data);
  }

  getAllFreeTimeSlot(data: any): Observable<any> {
    return this.api.post(environment.getAllFreeTimeSlot, data);
  }

  updateAppointment(data: any): Observable<any> {
    return this.api.post(environment.updateAppointment, data);
  }

  deleteAppointment(data: any): Observable<any> {
    return this.api.post(environment.deleteAppointment, data);
  }

  getLeadAnalytics(data: any): Observable<any> {
    return this.api.post(environment.getLeadAnalytics, data);
  }

  convertLeadSpaceToGroup(data: any): Observable<any> {
    return this.api.post(environment.createContactGroupListByLeadSpace, data);
  }

  deleteDuplicateLeads(data: any): Observable<any> {
    return this.api.post(environment.deleteDuplicateLeads, data);
  }

  getDuplicateLeads(data: any): Observable<any> {
    return this.api.post(environment.deleteDuplicateLeads, data);
  }

  exportLeadsToS3(data: any): Observable<any> {
    return this.api.post(environment.exportLeadsToS3, data);
  }
}
